import React from 'react';
import { PersonInformationListItem } from '../../../PersonInformationListItem/PersonInformationListItem';
import { PersonInformationList } from '../../../PersonInformationListItem';
import { ContactPerson } from '../../../../ContactPerson';

type ConnectedPageListItemPersonsProps = {
  persons: ContactPerson[];
  headline: string;
};
export function ConnectedPageListItemPersons({ persons, headline }: ConnectedPageListItemPersonsProps) {
  return persons
    ? (
        <PersonInformationList headline={headline} className="connected-page-list-item__person-container-list">
          {persons.map(person => (
            <PersonInformationListItem
              key={person.profileLink.url}
              className="connected-page-list-item__person-container-list-item"
              person={person}
            />
          ))}
        </PersonInformationList>
      )
    : null;
}
